import React, { ReactNode, useMemo } from 'react';
import Icon, { ICON_NAME } from "../../../../components/Icon";
import LoadingBox from "../../../../components/LoadingBox";
import { IDensityMap } from "../../../../util/varibles/interface";
import { KEY_SPLIT } from "../../constants";
import { jobName } from "../constants";
import { openDensity } from "../PopupDensity";
import styles from '../style.module.scss';

interface IProps {
    id?: string
    value?: { [value: string]: [number, number] }
    loading?: boolean
    title?: {
        view: ReactNode,
        source: IDensityMap
    }
    onSave: (value: IDensityMap) => void
}

const JobDensity: React.FC<IProps> = ({ id = '', value = {}, title, loading, onSave }) => {
    const isValue = useMemo(() => Object.keys(value).length > 0, [value]);
    const [opType, subType] = id.split(KEY_SPLIT);

    return <div className={styles.density} data-loading={loading} onClick={() => {
        if (!loading) openDensity({ id, value, combine: title?.source, onSave });
    }}>
        {loading && <LoadingBox className='mr-1' spinnerSize={18} loading={loading} />}
        {title
            ? <div>{title.view}</div>
            : <div className={styles.densityBt}>
                {isValue && <Icon icon={ICON_NAME.TANK_2} />}
                <div>{(isValue && id.length > 0) ? jobName(opType, subType) : 'Define'} density</div>
            </div>}
    </div>;
};

export default JobDensity;